import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {PriceRangePercentageBreakdown} from '../price-range.types'

@Component({
  selector: 'cft-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
  standalone: false,
})
export class PriceBreakdownComponent {
  @Input() breakdown!: PriceRangePercentageBreakdown
}
